import { createFileRoute } from '@tanstack/react-router';
import { UnitDetailView, UnitsProvider } from '@ludolio/shared-units';
import { useTeacherUnitsModule } from '@/units/teacherUnitsModule';

export const Route = createFileRoute('/_authenticated/units/$unitId')({
  component: function UnitDetailPage() {
    const { unitId } = Route.useParams();
    const module = useTeacherUnitsModule();
    return (
      <UnitsProvider module={module}>
        <UnitDetailView key={unitId} unitId={unitId} />
      </UnitsProvider>
    );
  },
});

